module.exports = __webpack_public_path__ + "img/frame (76).19b398ac.jpg";